import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Loader from 'components/Loader'
import PublicRoute from 'app/router/guards/PublicRoute'
import PrivateRoute from 'app/router/guards/PrivateRoute'

import Login from 'features/auth/pages/LoginPage'
import PageNotFound from 'app/pages/NotFoundPage'

import DefaultLayout from 'app/layout/DefaultLayout'

import AllRoutes from 'app/router'
import 'react-datepicker/dist/react-datepicker.css'
const App = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000)
  }, [])

  return loading ? (
    <Loader />
  ) : (
    <BrowserRouter>
      <Routes>
        <Route path='/*' element={<PageNotFound />} />
        <Route element={<PublicRoute />}>
          <Route path='/login' element={<Login />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route element={<DefaultLayout />}>
            {AllRoutes.map((route, index) => {
              return (
                <Route key={index} path={route.path} element={route.element} />
              )
            })}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
